import { render } from "./ListFiders.vue?vue&type=template&id=3ae027f7&lang=true"
import script from "./ListFiders.vue?vue&type=script&lang=js"
export * from "./ListFiders.vue?vue&type=script&lang=js"

import "./ListFiders.vue?vue&type=style&index=0&id=3ae027f7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__